// extracted by mini-css-extract-plugin
export default {"About":"About_About__b532O"};